import { Button } from "@/components/ui/button";
import { NavHeader } from "@/components/layout/nav-header";
import { useLocation } from "wouter";

export default function NotFound() {
  const [, setLocation] = useLocation();

  return (
    <div className="min-h-screen bg-clubhouse-black text-white">
      <NavHeader />
      
      <div className="flex flex-col items-center justify-center min-h-[calc(100vh-80px)] px-4">
        <div className="text-center max-w-2xl animate-page-in">
          <h1 className="text-6xl font-bold mb-4 text-white/40">404</h1>

          <h2 className="text-[28px] font-semibold mb-3">
            Page not found
          </h2>

          <p className="text-white/40 text-[18px] mb-8 max-w-sm mx-auto leading-relaxed">
            The page you're looking for doesn't exist or may have been moved.
          </p>
          
          <Button
            className="bg-white hover:bg-white/90 text-black font-medium px-8 py-3"
            onClick={() => setLocation("/")}
          >
            Go to homepage
          </Button>
        </div>
      </div>
    </div>
  );
}
